import styled, { css, keyframes } from "styled-components"
import { colors } from "../../../lib/colors"
import { tabletSmallText } from "../../../media_queries/TabletMediaQueries"
import { coefficientColorCheck } from "../../helpers/coefficientColor"

interface Elements_Styled_props {
  number: number
  shouldAnimate?: boolean
}

interface LessOrMore_Props {
  lessOrMore: boolean
}

export const PreviousNumbers = styled.div`
  display: flex;

  flex-wrap: wrap;
  width: 100%;
  position: relative;
  flex-direction: row;
  justify-content: flex-end;
  margin-bottom: 10px;
  margin-top: 4px;
`

const moveRight = keyframes`
  0% {
    left: -30px;
  }

  100%{
    left: 0;
  }
`

export const EachNumber = styled.div<Elements_Styled_props>`
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 100%;
  text-align: center;
  color: #ffffff;
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-left: 4px;
  margin-bottom: 4px;
  position: relative;
  align-items: center;
  align-items: stretch;
  min-width: 44px;
  padding: 4px 6px;
  gap: 30px;
  pointer-events: none;
  animation: ${({ shouldAnimate }) =>
    shouldAnimate !== undefined && shouldAnimate
      ? css`
          ${moveRight} 0.3s forwards
        `
      : ""};
  background: ${({ number }) => coefficientColorCheck(number)};
  border-radius: 2px;
  ${tabletSmallText}
`

export const LessContainerNumbers = styled.div`
  display: flex;
  border-radius: 2px;
  overflow-x: scroll;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
`

export const LessContainer = styled.div`
  display: flex;

  width: 100%;
  position: absolute;
  bottom: 0;
  padding: 0 28px;
  justify-content: flex-end;
`

export const MoreContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row-reverse;

  position: absolute;
  bottom: 0;
  flex-wrap: wrap-reverse;
  padding: 0 28px;
`

export const LessOrMoreBtn = styled.div<LessOrMore_Props>`
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 100%;
  text-align: center;
  color: #ffffff;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 4px 6px;
  margin-left: 4px;
  margin-bottom: 4px;
  gap: 10px;
  background: ${({ lessOrMore }) =>
    lessOrMore ? colors.redGradient : colors.blueGradient};
  text-transform: uppercase;
  border-radius: 2px;
  cursor: pointer;
  min-width: 44px;
  ${tabletSmallText}
`
